import { useState } from 'react';
import classNames from 'classnames';
import styles from '../../index.module.scss';
import type { AppGarageReview } from 'pages/api/getGaragesByLatLong';

interface ReviewQuoteProps {
  readonly text: AppGarageReview['text'];
  readonly authorName: AppGarageReview['authorName'];
  readonly relativeTime: AppGarageReview['relativeTime'];
}

export function ReviewQuote({ text, authorName, relativeTime }: ReviewQuoteProps): JSX.Element | null {
  const [showMore, setShowMore] = useState(false);

  if (!text) return null;

  return (
    <>
      <q
        className={classNames(styles.ReviewText, !showMore && styles.Hidden)}
        tabIndex={0}
        role="button"
        onClick={() => {
          setShowMore(!showMore);
        }}
        onKeyDown={() => setShowMore(!showMore)}
      >
        {text}
      </q>
      <div className={styles.ReviewAuthor}>
        {authorName} &mdash; {relativeTime}
      </div>
    </>
  );
}
